import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { motion } from 'framer-motion';
import { Formik } from 'formik';
import * as yup from 'yup';

import { GrLinkedin } from 'react-icons/gr';
import { FaDownload } from 'react-icons/fa';
import { animateScroll as scroll } from 'react-scroll';
import { backVariants, fade } from '~/styles/animations';
import { useUserContext } from '~/hooks/context/modules/UserContext';
import Loading from '~/components/Loading';
import useWindowDimensions from '~/hooks/useWindowDimensions';

import { Modal, Toast } from '~/components';

import notebook from '~/assets/img/imagem-notebook-certificado.png';
import logoAcelerador from '~/assets/img/logotipo-evento-ia.png';

import logo from '~/assets/img/Logotipo-Daxus-Branco.png';
import logoWhite from '~/assets/img/logowhite-l.png';

import api from '~/services/api';

import * as U from '~/styles/utilities';
import * as F from '~/styles/form';
import * as S from './styled';

const Certificate = () => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);
  const { width } = useWindowDimensions();

  const [loading, setLoading] = useState({ form: false, image: false });

  const [modalCertificate, setModalCertificate] = useState(false);
  const [CertificateData, setCertificateData] = useState({});

  const handleSubmitForm = async (data) => {
    const formattedData = { ...data, key_word: 'ia' };
    try {
      setLoading({ form: true, image: true });
      const response = await api.post('/generate-certificate', formattedData);

      setModalCertificate(true);
      setCertificateData(response.data);
      setLoading({ form: false, image: false });
    } catch (err) {
      Toast.error('Palavra-chave inválida');
      setLoading({ form: false, image: false });
    }
  };

  // form

  const initialValues = {
    username: '',
    email: '',
    key_word: '',
  };

  const validations = () =>
    yup.object().shape({
      username: yup.string().required('O nome é obrigatório'),

      email: yup
        .string()
        .email('Insira um e-mail válido')
        .required('O e-mail é obrigatório'),
    });

  return (
    <>
      <motion.div exit={{ opacity: 0 }} initial="initial" animate="animate">
        <S.BackgroundIaPage>
          <S.ContainerLimit>
            <U.Gap size={50} />
            <Grid container xs={12} justify="center">
              <Grid item xs={12} sm={4}>
                <img
                  src={logoAcelerador}
                  alt="logo"
                  style={{ width: '100%' }}
                />
              </Grid>
            </Grid>
            <U.Gap size={100} />
            <Grid container xs={12}>
              <Grid item xs={12} md={6}>
                <Grid xs={12} md={10}>
                  <motion.div variants={fade}>
                    <S.Title2>
                      <span>Parabéns</span> por ter chegado ao final do evento!
                    </S.Title2>
                    <U.Gap size={12} />
                    <S.Text2>
                      Agora chegou a hora de emitir seu certificado!
                    </S.Text2>
                    <S.Text2>Aproveite esse momento para:</S.Text2>
                    <U.Gap size={25} />
                    <Grid xs={12} sm={10}>
                      <S.UList2>
                        <li>
                          Compartilhar seu certificado no <span>LinkedIN</span>
                        </li>
                        <li>
                          Seguir a <span>Daxus</span> nas Redes Sociais
                        </li>
                        <li>
                          Conhecer nossa{' '}
                          <span>Formação Completa em Inteligência Artificial</span> (confira a
                          data da próxima turma)
                        </li>
                      </S.UList2>
                    </Grid>
                    <U.Gap size={30}>
                      <S.Text>
                        Obrigado por ter nos acompanhado até aqui!
                      </S.Text>
                    </U.Gap>
                  </motion.div>
                  <Grid container xs={12} justify="center">
                    <Grid item xs={12} sm={6} md={10}>
                      <motion.div variants={fade}>
                        <img
                          src={notebook}
                          alt="logo"
                          style={{ width: '100%' }}
                        />
                      </motion.div>
                    </Grid>
                  </Grid>
                  <U.Gap size={30} />
                </Grid>
              </Grid>

              <Grid item xs={12} md={6}>
                <motion.div initial="exit" animate="enter" exit="exit">
                  <motion.div variants={backVariants}>
                    <S.Card backgroundColor="#1F1640">
                      <Grid
                        container
                        justify="space-between"
                        alignItems="center"
                      >
                        <Grid item>
                          <S.TitleModal>
                            <span>Emita seu </span> certificado
                          </S.TitleModal>
                        </Grid>
                        <Grid item>
                          <S.LogoModal src={logo} alt="logo" width='180px' />
                        </Grid>
                      </Grid>
                      <U.Gap size={20} />
                      <Formik
                        initialValues={initialValues}
                        onSubmit={handleSubmitForm}
                        validationSchema={validations()}
                      >
                        {({
                          handleSubmit,
                          handleBlur,
                          handleChange,
                          values,
                          errors,
                          touched,
                          setFieldValue,
                        }) => (
                          <>
                            <form onSubmit={handleSubmit}>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <F.Label>Nome (máx. 30 caracteres)</F.Label>
                                  <F.Input
                                    type="text"
                                    placeholder="Digite seu nome"
                                    name="username"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.username}
                                    maxLength={30}
                                  />
                                  {errors.username && touched.username ? (
                                    <F.Hint
                                      error={
                                        !!errors.username && touched.username
                                      }
                                    >
                                      {errors.username}
                                    </F.Hint>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12}>
                                  <F.Label>E-mail cadastrado no evento</F.Label>
                                  <F.Input
                                    type="email"
                                    placeholder="Digite seu e-mail"
                                    name="email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                  />
                                  {errors.email && touched.email ? (
                                    <F.Hint
                                      error={!!errors.email && touched.email}
                                    >
                                      {errors.email}
                                    </F.Hint>
                                  ) : null}
                                </Grid>

                                <Grid
                                  item
                                  xs={12}
                                  container
                                  justify="flex-end"
                                  style={{ margin: '40px 0 32px 0px' }}
                                >
                                  <S.Button
                                    // whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    full
                                    type="submit"
                                    className="flex-center"
                                    disabled={loading.form}
                                  >
                                    {loading.form ? (
                                      <>
                                        <span>Emitindo certificado ...</span>
                                        <Loading />
                                      </>
                                    ) : (
                                      'Emita seu Certificado!'
                                    )}
                                  </S.Button>
                                </Grid>
                              </Grid>
                            </form>
                          </>
                        )}
                      </Formik>
                    </S.Card>
                  </motion.div>
                </motion.div>
              </Grid>
            </Grid>
            <U.Gap size={100} />
          </S.ContainerLimit>
        </S.BackgroundIaPage>

        <S.SeeMoreSection>
          <S.ContainerLimit>
            <Grid container justify="center" className="text-center">
              <Grid>
                <S.TitleBig>Veja mais sobre a </S.TitleBig>
                <S.TitleBig>
                  <span>Daxus</span>
                </S.TitleBig>
              </Grid>
            </Grid>
            <U.Gap size={50} />
            <Grid container xs={12} justify="center">
              <Grid item container xs={12} spacing={3}>
                <Grid item xs={12} lg={4}>
                  <a
                    href="https://www.daxus.com.br/formacao-ia"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <S.ButtonFooter2 whileTap={{ scale: 0.95 }}>
                      Curso completo de IA
                    </S.ButtonFooter2>
                  </a>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <a
                    href="https://www.instagram.com/daxusbrasil"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <S.ButtonFooter2 whileTap={{ scale: 0.95 }}>
                      Instagram
                    </S.ButtonFooter2>
                  </a>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <a
                    href="https://www.youtube.com/@daxusbrasil"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <S.ButtonFooter2 whileTap={{ scale: 0.95 }}>
                      Youtube
                    </S.ButtonFooter2>
                  </a>
                </Grid>
              </Grid>
            </Grid>
          </S.ContainerLimit>
        </S.SeeMoreSection>

        <Grid container justify="center" className="text-center">
          <Grid>
            <U.Gap size={20} />
            <img src={logoWhite} alt="logo-branca" style={{ width: '64px' }} />

            <S.Text>Daxus | Empowerdata agora é Daxus © 2025 - CNPJ: 27.955.892/0001-30</S.Text>
            <U.Text>Todos os direitos reservados</U.Text>
            <U.Gap size={20} />
          </Grid>
        </Grid>
      </motion.div>

      {modalCertificate && (
        <Modal
          onClose={() => setModalCertificate(false)}
          hasButton
          size={70}
          white
          contentPadding={width > 768 ? '2rem' : '4rem 1.5rem 1.5rem 1.5rem'}
        >
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              md={8}
              container
              alignItems="center"
              justify="center"
            >
              {!loading.image && (
                <Grid
                  item
                  xs={12}
                  md={8}
                  container
                  alignItems="center"
                  justify="center"
                  style={{ height: 460 }}
                >
                  <Loading />
                </Grid>
              )}
              <img
                src={CertificateData.certificate_image}
                alt="certificado"
                style={loading.image ? { width: '100%' } : { display: 'none' }}
                onLoad={() => setLoading({ form: false, image: true })}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <U.Gap size={width > 768 ? 50 : 0} />
              <S.TitleCertificate>
                Parabéns, {CertificateData.name}!
              </S.TitleCertificate>
              <U.Gap size={width > 768 ? 20 : 10} />
              <U.Text black bold>
                Aproveite e compartilhe mais essa conquista no seu Linkedin!
              </U.Text>

              <U.Gap size={30} />
              <a
                href={`https://www.linkedin.com/shareArticle?mini=true&url=${CertificateData.certificate_image}`}
                target="_blank"
                rel="noreferrer"
              >
                <S.ButtonFooter whileTap={{ scale: 0.95 }}>
                  <GrLinkedin size={20} color="#fff" /> Compartilhar no linkedIn
                </S.ButtonFooter>
              </a>
              <U.Gap size={20} />
              <a
                href={CertificateData.certificate}
                download="certificado.pdf"
                target="_blank"
                rel="noreferrer"
              >
                <S.ButtonFooter whileTap={{ scale: 0.95 }}>
                  <FaDownload size={20} color="#fff" /> Baixar certificado
                </S.ButtonFooter>
              </a>
            </Grid>
          </Grid>
        </Modal>
      )}
    </>
  );
};

export default Certificate;
